import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Site } from 'graphql-api/gql-api-interfaces';

import {
  clearSites,
  initSites,
  loadAllSitesSuccess,
  loadSiteSelectorBackgroundSuccess,
  loadSitesFailed,
  loadSitesSuccess,
  preloadSitesSuccess,
  setSelectedSite,
  updateCurrentSite,
} from './actions/sites.actions';
import { ISite } from './models';

export const currentAccountSites = 'currentAccountSites';
export const preloadSites = 'preloadSites';
export interface State extends EntityState<Site> {
  preloadSites: {
    [accountId: string]: Site[];
  };
  // will be saved in localStorage
  [currentAccountSites]: Site[];
  // current site of the app
  currentSite: ISite | null;
  background: string | null;
  // loading state
  loading: boolean;
  loaded: boolean;
  allSites: Site[];
}

export const adapter: EntityAdapter<Site> = createEntityAdapter<Site>({
  selectId: (site: Site) => site.siteId,
  sortComparer: false,
});

export const initialState: State = adapter.getInitialState({
  [preloadSites]: {},
  [currentAccountSites]: [],
  currentSite: null,
  background: null,
  loading: false,
  loaded: false,
  allSites: [],
});

export const reducer = createReducer(
  initialState,

  on(clearSites, ({ currentSite }) => ({ ...initialState, currentSite })),

  on(initSites, (state) => ({ ...state, loading: true })),

  on(loadSiteSelectorBackgroundSuccess, (state, { background }) => ({
    ...state,
    background,
  })),

  on(loadSitesSuccess, (state, { sites }) =>
    adapter.setAll(sites, {
      ...state,
      [currentAccountSites]: sites,
      loading: false,
      loaded: true,
    }),
  ),

  on(loadSitesFailed, (state) =>
    adapter.removeAll({ ...state, ...initialState }),
  ),

  on(setSelectedSite, (state, { site }) => ({
    ...state,
    currentSite: site,
  })),

  on(updateCurrentSite, (state, { site }) => ({
    ...state,
    currentSite: site,
  })),

  on(preloadSitesSuccess, (state, { accountId, sites }) => ({
    ...state,
    [preloadSites]: {
      ...state[preloadSites],
      [accountId]: sites,
    },
  })),
  on(
    loadAllSitesSuccess,
    (state, { sites }): State => ({
      ...state,
      allSites: sites,
    }),
  ),
);
